import React from "react";
import PageLayout from '../../Components/PageLayout';
function Nest() {
    return (
        <PageLayout title="Nest" subtitle="Nest overview">
            <div className="container flex col box-container">
                {/* <div className="box">Nest</div>
                <div className="box">Nest</div>
                <div className="box">Nest</div> */}
            </div>
        </PageLayout>
    );
}

export default Nest;
